import Page from "@/lib/components/Page";
import {useProfile} from "@/lib/components/ProfileProvider";
import ErrorPage from "@/lib/components/ErrorPage";
import SpinnerPage from "@/lib/components/SpinnerPage";
import Header from "@/lib/components/Header";
import AvatarRow from "@/lib/components/AvatarRow";
import {rowColor} from "@/lib/styles";
import {useRouter} from "expo-router";
import AvatarTable from "@/lib/components/AvatarTable";

export default function Index() {
    const {profile, profileError, profileLoading} = useProfile();
    const router = useRouter();

    if (profileError) {
        return <ErrorPage error={profileError}/>
    } else if (profileLoading || !profile) {
        return <SpinnerPage/>
    }

    return (
        <Page scrollable={true}>
            <Header title={`Omgangskretsen til deg og ${profile.avatar.username} ( ${profile.potential_relationships.length} )`}/>
            <AvatarTable>
                {profile.potential_relationships.map((avatar, index) => (
                    <AvatarRow key={avatar.id}
                               avatar={avatar}
                               badgeColor={profile.avatar.color}
                               color={rowColor(profile.avatar.color, index)}
                               contrastColor={profile.avatar.contrast_color}
                               onPress={() => {
                                   router.push(`/u/profile/${avatar.username}`);
                               }}
                    />
                ))}
            </AvatarTable>
        </Page>
    )
}